import {
  put, takeLatest, takeEvery, all, select,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TagActions, { tagActionTypes } from '@Actions/tagActions';
import TrackerActions from '@Actions/trackerActions';
import TagServices from '@Services/tagServices';

function* _createTag(action) {
  try {
    yield put(TagActions.createTagLoading(true));
    const { payload } = action;
    const tag = yield TagServices.createTag(payload);
    if (action?.callback) action.callback(tag?.data?.tags);
    yield put(TagActions.createTagLoading(false));
  } catch (error) {
    yield put(TagActions.createTagLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tagActionTypes.CREATE_TAG.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* createTag() {
  yield takeLatest(tagActionTypes.CREATE_TAG.REQUEST, _createTag);
}

/**
 * @param action
 */
function* _getTags(action) {
  const {
    entityName, page, limit, searchKeyword, callback,
  } = action;
  try {
    yield put(TagActions.getTagsLoading(true, entityName));
    const state = yield select();
    const orgId = state.UserReducers?.user?.tenant_info?.org_id;
    const tags = yield TagServices.getTags(orgId, entityName, page, limit, searchKeyword);
    yield put(TagActions.getTagsSuccess(tags, entityName));
    if (callback) callback();
    yield put(TagActions.getTagsLoading(false, entityName));
  } catch (error) {
    yield put(TagActions.getTagsLoading(false, entityName));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tagActionTypes.GET_TAGS.ERROR, error));
  }
}

/**
 *
 */
function* getTags() {
  yield takeEvery(tagActionTypes.GET_TAGS.REQUEST, _getTags);
}

export default function* tagSaga() {
  yield all([
    createTag(),
    getTags(),
  ]);
}
